import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/user"
  }, React.createElement("path", {
    id: "Vector",
    d: "M8 1C9.89086 1 11.4286 2.47741 11.4286 4.29412V5.11765C11.4286 6.93435 9.89086 8.41177 8 8.41177C6.10914 8.41177 4.57143 6.93435 4.57143 5.11765V4.29412C4.57143 2.47741 6.10914 1 8 1ZM4.54057 8.76259C5.48408 9.59565 6.71859 10.0582 8 10.0588C9.33286 10.0588 10.5449 9.56471 11.4594 8.76259C12.9689 9.23529 14 10.3149 14 11.7059V14.1765C12.0003 14.7258 9.99971 15 8 15C6.00029 15 3.99971 14.7258 2 14.1765V11.7059C2 10.3149 3.03114 9.23529 4.54057 8.76259Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { User16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var User16 = createIcon(IconComponent);